import NextLink from 'next/link'
import { twMerge } from 'tailwind-merge'

interface LinkProps extends React.ComponentProps<typeof NextLink> {
  className?: string
}

export const Link: React.FC<LinkProps> = ({ className, ...props }) => {
  return (
    <NextLink
      className={twMerge(
        'text-primary-900 dark:text-primary-100 hover:text-blue-600 dark:hover:text-blue-400',
        className,
      )}
      {...props}
    />
  )
}
